import React from "react";
import "./style.css";

function Content({ data }) {
  return (
    <div className="experience-description-container">
      <h3>{data.company}</h3>
      <h4>{data.title}</h4>
      <p>{data.date}</p>
      <ul>
        {data.works.map((work) => {
          return <li>{work}</li>;
        })}
      </ul>
    </div>
  );
}

export default Content;
